import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { ScrollText, ShieldCheck } from "lucide-react";

export const Registry = () => {
  const { data } = useQuery({
    queryKey: ["registry-parcels"],
    queryFn: async () => (await api.get("/land/parcels", { params: { limit: 120 } })).data,
  });
  const items = (data?.items || []).filter((p) => p.title_registered);

  return (
    <div className="space-y-6" data-testid="page-registry">
      <header>
        <div className="font-mono-cad text-[10px] uppercase tracking-[0.28em] text-[#7C93A5]">Registry360™ · Rights360™</div>
        <h1 className="font-display text-3xl font-bold text-[#F6F8FA] mt-1">Registered Titles</h1>
        <div className="text-[13px] text-[#B3C2CC] mt-1">Digital title deeds, restrictions, servitudes and beneficial interests.</div>
      </header>
      <div className="cad-panel overflow-hidden">
        <table className="w-full text-[13px]">
          <thead>
            <tr className="text-left border-b cad-hairline">
              {["Title Ref","Rights Holder","Province","District","Tenure","Area","Restrictions"].map((h) => (
                <th key={h} className="px-3 py-2.5 font-mono-cad text-[10px] uppercase tracking-[0.18em] text-[#7C93A5]">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="cad-tbody">
            {items.map((p) => (
              <tr key={p.id} data-testid={`registry-row-${p.id}`}>
                <td className="px-3 py-2 font-mono-cad text-[#F6F8FA] flex items-center gap-1.5"><ScrollText size={12} className="text-[#C99A2E]" />{p.parcel_number}</td>
                <td className="px-3 py-2 text-[#DCE3E8]">{p.rights_holder}</td>
                <td className="px-3 py-2">{p.province}</td>
                <td className="px-3 py-2">{p.district}</td>
                <td className="px-3 py-2 capitalize text-[#B3C2CC]">{(p.tenure || "").replace(/_/g, " ")}</td>
                <td className="px-3 py-2 font-mono-cad">{p.area_ha}</td>
                <td className="px-3 py-2"><span className="cad-chip cad-chip-green"><ShieldCheck size={11}/> Clean</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
